export const LOGIN_FAILED = 'LOGIN_FAILED'
export const RESET_PASSWORD_SUCCEEDED = 'RESET_PASSWORD_SUCCEEDED'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const DISMISS_SNACKBAR ='DISMISS_SNACKBAR'
